// extracted by mini-css-extract-plugin
export var orange = "Spacer-module--orange--8-XeO";
export var root = "Spacer-module--root--sx025";
export var x2 = "Spacer-module--x2--4-4as";
export var x3 = "Spacer-module--x3--K0tmc";